const dataLayer = window.dataLayer;

// utility function for 'virtualPageView' events that prepends "/vpv/" to a given url
export function buildVirtualPageViewURL(url) {
    //remove all forward-slash characters from the url
    url = '/vpv/' + url.replace(/^\/*/, '');

    return url;
}

export function pushCheckboxState(checkboxName, checkboxState) {
    
    if (dataLayer === undefined) {
        return;
    }

    dataLayer.push(
        { event: checkboxName, value: checkboxState }
    );
}

export function pushRegistrationVirtualPageView() {

    if (dataLayer === undefined) {
        return;
    }

    dataLayer.push(
        { event: 'virtualPageView', virtualPageURL: buildVirtualPageViewURL('/user-registration') }
    );

}

export function pushRegistrationSavePackageSelection() {

    if (dataLayer === undefined) {
        return;
    }

    dataLayer.push(
        { event: 'virtualPageView', virtualPageURL: buildVirtualPageViewURL('/user-registration/package-selection') }
    );

}

export function pushRegistrationSavePersonalInformation() {
    
    if (dataLayer === undefined) {
        return;
    }

    dataLayer.push(
        { event: 'virtualPageView', virtualPageURL: buildVirtualPageViewURL('/user-registration/personal-information') }
    );

}

export function pushRegistrationConfirmationVirtualPageView(context, data, registrationModel) {

    if (dataLayer === undefined) {
        return;
    }

    pushMemberInfoGA(data.contactNumber, data.orgNumber);  

    let confirmationPageUrl = context == 'ADD_CONTACT' ? '/user-add-contact' : '/user-registration';

    let confirmationType = '/confirmation';
    // check if the registration is a free subscription
    if (registrationModel.registrationModel.selectedSubscriptionPackage.freePackage) {
        // check if VAS item(s) were selected, otherwise consider registration as free
        if (registrationModel.registrationModel.subscription.vasItemIds &&
            registrationModel.registrationModel.subscription.vasItemIds.length > 0) {
            confirmationType = '/confirmation-free-ad';
        } else {
            confirmationType = '/confirmation-free';
        }
    }

    dataLayer.push(
        { event: 'virtualPageView', virtualPageURL: buildVirtualPageViewURL(confirmationPageUrl + confirmationType) }
    );
    
}

export function pushRegistrationECommerceData(eCommerceData, eCommerceEventData, eCommerceUserData, context, isBillingRequired) {
    
    if (dataLayer === undefined) {
        return;
    }

    if(eCommerceUserData) {
        dataLayer.push(eCommerceUserData)
    }

    if (eCommerceData) {

        if (context === 'ADD_CONTACT') {
            eCommerceData.event = isBillingRequired ? 'newPaidAddContact' : 'newFreeAddContact';
        } else {
            eCommerceData.event = isBillingRequired ? 'newPaidRegistration' : 'newFreeRegistration';
        }

        dataLayer.push(eCommerceData);
        
    }

    if (eCommerceEventData) {
        dataLayer.push(eCommerceEventData);
    }

}

function pushMemberInfoGA(contactNo, orgNo){

    dataLayer.push({
        'memberType': 'Supplier',
        'organizationNumber': orgNo,
        'contactNumber': contactNo
    });
    
}